export var EmptyStatisticsData = {
    betRadarData: {
        clientId: "",
        eventId: ""
    },
    enetPulseData: {
        homeTeamId: -1,
        awayTeamId: -1,
        sportId: ""
    }
};
//# sourceMappingURL=emptyStatisticsData.js.map